import moment from 'moment';
import * as yup from 'yup';

const DIGITS_ONLY_REGEX = /^[0-9]+$/;

export const normalizeGender = gender => {
  const normalizedGender = (gender || '').toString().trim().toLowerCase();

  if (['masculino', 'masculinos', 'male', 'm'].includes(normalizedGender)) {
    return 'Masculino';
  }

  if (['feminino', 'femininos', 'female', 'f'].includes(normalizedGender)) {
    return 'Feminino';
  }

  return '';
};

export const createValidationSchema = t => {
  const requiredFieldError = t("common.form.errors.mandatory_field");
  const invalidNumberError = t("user_profile_page.errors.invalid_number");
  const requiredNumberFieldError = `${requiredFieldError} - ${invalidNumberError}`;
  const emailFieldError = t("common.form.errors.invalid_email");
  const numberFieldError = t("user_profile_page.errors.not_a_number");
  const invalidYearError = t("common.form.errors.invalid_year");

  return yup.object().shape({
    name: yup
      .string()
      .trim()
      .required(requiredFieldError),
    birthyear: yup
      .string()
      .trim()
      .required(requiredNumberFieldError)
      .matches(DIGITS_ONLY_REGEX, numberFieldError)
      .test({
        name: "Birthyear error",
        message: invalidYearError,
        test: value => {
          const birthyear = parseInt(value, 10);
          return birthyear > moment().year() - 70 && birthyear < moment().year() - 12;
        }
      }),
    gender: yup
      .string()
      .nullable(true)
      .trim()
      .oneOf(['', 'Masculino', 'Feminino'], requiredFieldError),
    phone: yup
      .string()
      .trim()
      .required(requiredFieldError)
      .matches(DIGITS_ONLY_REGEX, t("common.form.errors.special_characters"))
      .min(9, t("common.form.errors.invalid_phone_number")),
    fppLicence: yup.string().when('hasFppLicence', {
      is: true,
      then: yup
        .string()
        .required(requiredNumberFieldError)
        .matches(DIGITS_ONLY_REGEX, numberFieldError),
      otherwise: yup.string().notRequired()
    }),
    email: yup
      .string()
      .trim()
      .required(requiredFieldError)
      .email(emailFieldError),
    facebook: yup
      .string()
      .when('hasSocialMedia', {
        is: true,
        then: yup
          .string()
          .required(requiredFieldError)
          .matches(/^[A-Za-z0-9.]*$/, t("user_profile_page.errors.invalid_facebook")),
        otherwise: yup.string().notRequired()
      }),
    password: yup
      .string()
      .test({
        name: "Password length",
        message: t("common.form.errors.invalid_password"),
        test: value => !value || value.length >= 8
      }),
    passwordConfirmation: yup
      .string()
      .when('password', {
        is: password => !!password,
        then: yup
          .string()
          .required(requiredFieldError)
          .oneOf([yup.ref('password')], t("common.form.errors.matching_passwords")),
        otherwise: yup.string().notRequired()
      })
  });
};

export default createValidationSchema;
